import { render } from "./ItemSignIn.vue?vue&type=template&id=d6fe9a80"
import script from "./ItemSignIn.vue?vue&type=script&lang=js"
export * from "./ItemSignIn.vue?vue&type=script&lang=js"

import "./ItemSignIn.vue?vue&type=style&index=0&id=d6fe9a80&lang=scss"

import exportComponent from "/Users/anwarfuadi/Documents/nyp/gigihpack.com/fe/gigihpack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__